import { forwardRef } from "react";
import PropTypes from "prop-types";

const InputCheckbox = forwardRef(
  ({ label, checked, onChange, error, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            ref={ref}
            checked={checked}
            onChange={onChange}
            className={`w-5 h-5 input-base transition cursor-pointer ${
              error
                ? "border-red-500 ring-1 ring-red-500"
                : "focus:ring-1 focus:ring-blue-500"
            }`}
            {...props}
          />
          {label && (
            <label className="text-base md:text-sm font-medium cursor-pointer">
              {label}
            </label>
          )}
        </div>
        {error && <p className="text-red-500 text-xs mt-1 pl-1">{error}</p>}
      </div>
    );
  }
);

InputCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string,
};

InputCheckbox.displayName = "InputCheckbox";

export default InputCheckbox;
